var Bavaria = "巴伐利亞";
var Berlin = "柏林";
var Brandenburg = "布蘭登堡";
var Bremen = "布萊梅";
var Hamburg = "漢堡";
var Hesse = "赫塞";
var Saarland = "薩爾蘭";
var Saxony = "薩克森";
var Thuringia = "圖林根";
var DEStates = {
	"Baden-Wuerttemberg": "巴登-符騰堡",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "麥克倫堡-佛波門",
	"Lower Saxony": "下薩克森",
	"North Rhine-Westphalia": "北萊茵-西伐利亞",
	"Rhineland-Palatinate": "萊茵蘭-普法茲",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "薩克森-安哈特",
	"Schleswig-Holstein": "什勒斯維希-霍爾斯坦",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
